import * as React from 'react';
import * as styles from './Background.css';
import { Image } from '@cian/ui-kit';
export function Background(_ref) {
  var width = _ref.width,
      height = _ref.height,
      slices = _ref.slices,
      onReady = _ref.onReady;
  var imageSet = React.useRef(new Set());
  var handleReadyImage = React.useCallback(function (e) {
    imageSet.current.add(e.currentTarget.src);

    if (imageSet.current.size === slices.length) {
      onReady();
    }
  }, [onReady, slices.length]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['bg'],
    style: {
      width: "".concat(width, "px"),
      height: "".concat(height, "px")
    }
  }, slices.map(function (_ref2, index) {
    var rect = _ref2.rect,
        url = _ref2.url;
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "slice",
      key: "slice-".concat(index),
      className: styles['slice'],
      style: {
        left: "".concat(rect.x, "px"),
        top: "".concat(rect.y, "px"),
        width: "".concat(rect.w, "px"),
        height: "".concat(rect.h, "px")
      }
    }, /*#__PURE__*/React.createElement(Image, {
      src: url,
      onLoad: handleReadyImage
    }));
  }));
}